<template>
  <div class="up-page">
    <div class="up-card" :class="{ 'up-card--shake': shaking }">

      <!-- Icon header -->
      <div class="up-icon-wrap">
        <div class="up-icon-ring">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0110 0v4"/>
          </svg>
        </div>
      </div>

      <h2 class="up-title">تغيير كلمة المرور</h2>
      <p class="up-subtitle">أدخل كلمة المرور الجديدة أدناه</p>

      <form @submit.prevent="sendForm" class="up-form" novalidate>

        <!-- New password field -->
        <div class="uf-group" :class="{ 'uf-group--focus': focused, 'uf-group--error': v$.new_password.$error }">
          <label class="uf-label">كلمة المرور الجديدة</label>
          <div class="uf-input-wrap">
            <span class="uf-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
            </span>
            <input
              :type="showPass ? 'text' : 'password'"
              v-model="new_password"
              class="uf-input"
              placeholder=" "
              dir="ltr"
              @focus="focused = true"
              @blur="focused = false"
              autocomplete="new-password"
            />
            <button type="button" class="uf-eye" @click="showPass = !showPass" tabindex="-1">
              <svg v-if="!showPass" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19M1 1l22 22"/>
              </svg>
            </button>
          </div>
          <span class="uf-error" v-if="v$.new_password.$error">برجاء إدخال كلمة المرور الجديدة</span>
        </div>

        <!-- Strength hint -->
        <div class="uf-strength" v-if="new_password">
          <div class="uf-strength-bar">
            <div class="uf-strength-fill" :class="strengthClass" :style="{ width: strengthPct + '%' }"></div>
          </div>
          <span class="uf-strength-label" :class="strengthClass">{{ strengthLabel }}</span>
        </div>

        <!-- Submit -->
        <button type="submit" class="up-submit" :disabled="formSending">
          <span v-if="!formSending">🔐 حفظ كلمة المرور</span>
          <span v-else class="up-spinner"></span>
        </button>

      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "user-edit",
  data() {
    return {
      v$: useVuelidate(),
      new_password: "",
      formSending: false,
      showPass: false,
      focused: false,
      shaking: false,
      user_id: JSON.parse(localStorage.getItem("user")).id,
    };
  },
  computed: {
    strengthScore() {
      const p = this.new_password;
      if (!p) return 0;
      let score = 0;
      if (p.length >= 6)  score++;
      if (p.length >= 10) score++;
      if (/[A-Z]/.test(p)) score++;
      if (/[0-9]/.test(p)) score++;
      if (/[^A-Za-z0-9]/.test(p)) score++;
      return score;
    },
    strengthPct() {
      return Math.max(20, (this.strengthScore / 5) * 100);
    },
    strengthClass() {
      if (this.strengthScore <= 1) return 'str--weak';
      if (this.strengthScore <= 3) return 'str--fair';
      return 'str--strong';
    },
    strengthLabel() {
      if (this.strengthScore <= 1) return 'ضعيفة';
      if (this.strengthScore <= 3) return 'متوسطة';
      return 'قوية';
    },
  },
  validations() {
    return { new_password: { required } };
  },
  methods: {
    shake() {
      this.shaking = true;
      setTimeout(() => { this.shaking = false; }, 600);
    },
    sendForm() {
      this.v$.$validate();
      if (this.v$.$error) { this.shake(); return; }

      const formData = new FormData();
      formData.append('user_id', this.user_id);
      formData.append('password', this.new_password);
      this.formSending = true;

      axios.post('/update_password', formData)
        .then(() => {
          Swal.fire({ position: "center", icon: "success", title: "تم تحديث كلمة المرور بنجاح" });
          this.new_password = "";
          this.v$.$reset();
        })
        .catch((error) => {
          this.shake();
          Swal.fire({ position: "center", icon: "error", title: error.response?.data?.message });
        })
        .finally(() => { this.formSending = false; });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;800&display=swap');
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

.up-page {
  min-height: calc(100vh - 70px);
  background: #F5F7FB;
  display: flex; align-items: center; justify-content: center;
  font-family: 'Cairo', sans-serif;
  direction: rtl;
  padding: 2rem 1.25rem;
}

.up-card {
  width: 100%; max-width: 460px;
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(20px);
  border-radius: 28px;
  padding: 2.5rem 2rem;
  box-shadow: 0 24px 80px rgba(91,95,239,0.12), 0 4px 16px rgba(0,0,0,0.06);
  border: 1px solid rgba(255,255,255,0.9);
  text-align: center;
}
.up-card--shake { animation: upShake 0.5s cubic-bezier(.36,.07,.19,.97); }
@keyframes upShake {
  0%,100%{transform:translateX(0)} 15%{transform:translateX(-8px)} 30%{transform:translateX(8px)}
  45%{transform:translateX(-6px)} 60%{transform:translateX(6px)} 75%{transform:translateX(-4px)} 90%{transform:translateX(4px)}
}

/* Icon */
.up-icon-wrap { display: flex; justify-content: center; margin-bottom: 1.25rem; }
.up-icon-ring {
  width: 72px; height: 72px;
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF);
  border-radius: 22px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 16px 40px rgba(91,95,239,0.35);
}
.up-icon-ring svg { width: 34px; height: 34px; stroke: #fff; }

.up-title { font-size: 1.5rem; font-weight: 800; color: #1A1A1A; margin-bottom: 0.35rem; }
.up-subtitle { font-size: 0.88rem; color: #6B7280; margin-bottom: 2rem; }

/* Form */
.up-form { display: flex; flex-direction: column; gap: 1.25rem; text-align: right; }

/* Field */
.uf-group { position: relative; }
.uf-label {
  display: block; font-size: 0.84rem; font-weight: 700;
  color: #6B7280; margin-bottom: 0.4rem; transition: color 0.25s;
}
.uf-group--focus .uf-label { color: #5B5FEF; }
.uf-group--error .uf-label { color: #EF4444; }

.uf-input-wrap { position: relative; display: flex; align-items: center; }
.uf-icon {
  position: absolute; right: 14px;
  width: 20px; height: 20px;
  color: #9CA3AF; pointer-events: none;
  display: flex; align-items: center; justify-content: center;
  transition: color 0.25s;
}
.uf-icon svg { width: 18px; height: 18px; }
.uf-group--focus .uf-icon { color: #5B5FEF; }
.uf-group--error .uf-icon { color: #EF4444; }

.uf-input {
  width: 100%;
  padding: 0.85rem 2.75rem 0.85rem 2.75rem;
  border: 2px solid #E5E7EB;
  border-radius: 14px;
  font-family: 'Cairo', sans-serif;
  font-size: 0.95rem;
  color: #1A1A1A;
  background: #F9FAFB;
  outline: none;
  transition: border-color 0.25s, box-shadow 0.25s, background 0.25s;
}
.uf-input:focus {
  border-color: #5B5FEF;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(91,95,239,0.1);
}
.uf-group--error .uf-input { border-color: #EF4444; box-shadow: 0 0 0 4px rgba(239,68,68,0.08); }

.uf-eye {
  position: absolute; left: 12px;
  background: none; border: none; cursor: pointer;
  color: #9CA3AF; padding: 4px;
  display: flex; align-items: center; justify-content: center;
  transition: color 0.2s;
}
.uf-eye:hover { color: #5B5FEF; }
.uf-eye svg { width: 18px; height: 18px; }

.uf-error { font-size: 0.78rem; color: #EF4444; font-weight: 600; margin-top: 0.3rem; display: block; }

/* Strength */
.uf-strength { display: flex; align-items: center; gap: 0.75rem; }
.uf-strength-bar {
  flex: 1; height: 6px; background: #E5E7EB; border-radius: 99px; overflow: hidden;
}
.uf-strength-fill { height: 100%; border-radius: 99px; transition: width 0.4s ease, background 0.4s; }
.str--weak  .uf-strength-fill, .str--weak  { color: #EF4444; background: #EF4444; }
.str--fair  .uf-strength-fill, .str--fair  { color: #F59E0B; background: #F59E0B; }
.str--strong .uf-strength-fill, .str--strong { color: #22C55E; background: #22C55E; }
.uf-strength-label { font-size: 0.78rem; font-weight: 700; white-space: nowrap; }

/* Submit */
.up-submit {
  width: 100%; padding: 0.95rem;
  border: none; border-radius: 14px;
  background: linear-gradient(135deg, #5B5FEF, #7C4DFF);
  color: #fff;
  font-family: 'Cairo', sans-serif;
  font-size: 1.05rem; font-weight: 800;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(91,95,239,0.35);
  transition: all 0.3s;
  display: flex; align-items: center; justify-content: center;
  min-height: 54px; margin-top: 0.25rem;
}
.up-submit:hover:not(:disabled) { transform: translateY(-3px); box-shadow: 0 20px 45px rgba(91,95,239,0.45); }
.up-submit:disabled { opacity: 0.75; cursor: not-allowed; }

.up-spinner {
  width: 24px; height: 24px;
  border: 3px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: upSpin 0.8s linear infinite;
  display: inline-block;
}
@keyframes upSpin { to { transform: rotate(360deg); } }
</style>
